import React, { Component, Fragment } from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Heading from "../../components/Heading";

import {
    Button, Tabs, Tab, Paper, Hidden, TextField, MenuItem, AppBar,
    Select, Checkbox, ListItemText
} from "@material-ui/core";

import PendingGigPromotions from "./Tabs/PendingGigPromotions";
import PublishedGigPromotions from "./Tabs/PublishedGigPromotions";
import CompletedGigPromotions from "./Tabs/CompletedGigPromotions";
import OztixSyncModal from "./OztixSyncModal";

@withRouter
@inject("venueStore")
@observer
class GigPromotionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: 0,
            canCreateGigPromotion: false,
            venues: [],
            selectedVenueIds: [],
            startDate: null,
            endDate: null,
            selectedFilter: null,
            showCustomPicker: false,
            currentPage: 1,
            oztixSyncOpen: false,
            searchInput: "",
            searchQuery: "",
        };
        this._searchDebounceTimer = null;
    }

    componentDidMount() {
        this._isMounted = true;
        const { match } = this.props;

        this.props.venueStore.getUserVenuesBasedOnPermission(null, null, null, null, true).then(response => {
            const venues = Array.isArray(response) ? response : [];
            if (this._isMounted) this.setState({ canCreateGigPromotion: venues.length > 0, venues });
        }).catch(() => {
            if (this._isMounted) this.setState({ canCreateGigPromotion: false, venues: [] });
        });

        switch (match.params.activeTab) {
            case "draft":    this.setState({ tabValue: 0 }); break;
            case "published": this.setState({ tabValue: 1 }); break;
            case "past":     this.setState({ tabValue: 2 }); break;
            default:          this.setState({ tabValue: 0 }); break;
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.activeTab !== this.props.match.params.activeTab) {
            switch (this.props.match.params.activeTab) {
                case "draft":    this.setState({ tabValue: 0, currentPage: 1 }); break;
                case "published": this.setState({ tabValue: 1, currentPage: 1 }); break;
                case "past":     this.setState({ tabValue: 2, currentPage: 1 }); break;
                default:          this.setState({ tabValue: 0, currentPage: 1 }); break;
            }
        }
    }

    handleFilterChange = value => {
        this.setState({ selectedFilter: value, currentPage: 1 });
        if (value === "all") {
            this.setState({ startDate: null, endDate: null, showCustomPicker: false });
        } else if (value === "today") {
            this.setState({ startDate: moment().startOf("day"), endDate: moment().endOf("day"), showCustomPicker: false });
        } else if (value === "week") {
            this.setState({ startDate: moment().startOf("isoWeek"), endDate: moment().endOf("isoWeek"), showCustomPicker: false });
        } else if (value === "month") {
            this.setState({ startDate: moment().startOf("month"), endDate: moment().endOf("month"), showCustomPicker: false });
        } else if (value === "nextMonth") {
            this.setState({
                startDate: moment().add(1, "month").startOf("month"),
                endDate: moment().add(1, "month").endOf("month"),
                showCustomPicker: false,
            });
        } else if (value === "custom") {
            this.setState({ showCustomPicker: true });
        }
    };

    handleVenueChange = e => {
        this.setState({ selectedVenueIds: e.target.value, currentPage: 1 });
    };

    handleSearchChange = e => {
        const searchInput = e.target.value;
        this.setState({ searchInput });
        clearTimeout(this._searchDebounceTimer);
        this._searchDebounceTimer = setTimeout(() => {
            this.setState({ searchQuery: searchInput, currentPage: 1 });
        }, 500);
    };

    handleSearchClear = () => {
        clearTimeout(this._searchDebounceTimer);
        this.setState({ searchInput: "", searchQuery: "", currentPage: 1 });
    };

    renderCurrentTab = () => {
        const { tabValue, startDate, endDate, selectedVenueIds, currentPage, reloadKey, searchQuery } = this.state;
        const filterProps = {
            startDate,
            endDate,
            venueIds: selectedVenueIds,
            currentPage,
            reloadKey: reloadKey || 0,
            searchQuery,
            onPageChange: p => this.setState({ currentPage: p }),
        };
        switch (tabValue) {
            case 0: return <PendingGigPromotions {...filterProps} />;
            case 1: return <PublishedGigPromotions {...filterProps} />;
            case 2: return <CompletedGigPromotions {...filterProps} />;
            default: return <PendingGigPromotions {...filterProps} />;
        }
    };

    handleTabChange = (event, value) => {
        switch (value) {
            case 0: this.props.history.replace("/gig/promotion/draft"); break;
            case 1: this.props.history.replace("/gig/promotion/published"); break;
            case 2: this.props.history.replace("/gig/promotion/past"); break;
            default: this.props.history.replace("/gig/promotion/draft"); break;
        }
        this.setState({ tabValue: value, currentPage: 1 });
    };

    handleSelectChange = event => {
        switch (event.target.value) {
            case 0: this.props.history.replace("/gig/promotion/draft"); break;
            case 1: this.props.history.replace("/gig/promotion/published"); break;
            case 2: this.props.history.replace("/gig/promotion/past"); break;
            default: this.props.history.replace("/gig/promotion/draft"); break;
        }
        this.setState({ tabValue: event.target.value, currentPage: 1 });
    };

    handleOpenNewGigPromotionPage = () => {
        this.props.history.push("/gig/promotion/new");
    };

    handleSyncComplete = () => {
        this.setState(prev => ({ reloadKey: (prev.reloadKey || 0) + 1, currentPage: 1 }));
    };

    isFiltering = () => {
        const { selectedFilter, selectedVenueIds, searchQuery } = this.state;
        return (selectedFilter && selectedFilter !== "all") || selectedVenueIds.length > 0 || !!searchQuery;
    };

    renderFilterBar = () => {
        const { selectedFilter, showCustomPicker, startDate, endDate, venues, selectedVenueIds, searchInput } = this.state;
        const filters = [
            { key: "all",       label: "All" },
            { key: "today",     label: "Today" },
            { key: "week",      label: "This Week" },
            { key: "month",     label: "This Month" },
            { key: "nextMonth", label: "Next Month" },
            { key: "custom",    label: "Custom" },
        ];

        const venueLabel = selectedVenueIds.length === 0
            ? "All Venues"
            : selectedVenueIds.length === 1
                ? (venues.find(v => String(v.id) === String(selectedVenueIds[0]))?.profileName || "1 venue")
                : `${selectedVenueIds.length} venues`;

        return (
            <div style={{ padding: "12px 16px", borderBottom: "1px solid rgba(255,255,255,0.1)", backgroundColor: "#3A3B3D" }}>
                {/* Search input */}
                <div style={{ marginBottom: 10 }}>
                    <div style={{ position: "relative", display: "inline-flex", alignItems: "center", width: "100%", maxWidth: 380 }}>
                        <input
                            type="text"
                            value={searchInput}
                            onChange={this.handleSearchChange}
                            placeholder="Search by act, venue, or title…"
                            style={{
                                width: "100%",
                                padding: "7px 36px 7px 12px",
                                borderRadius: 6,
                                border: "1px solid rgba(255,255,255,0.25)",
                                backgroundColor: "rgba(255,255,255,0.08)",
                                color: "#fff",
                                fontSize: 13,
                                fontFamily: "inherit",
                                outline: "none",
                                boxSizing: "border-box",
                            }}
                        />
                        {searchInput ? (
                            <span
                                onClick={this.handleSearchClear}
                                style={{ position: "absolute", right: 10, cursor: "pointer", color: "rgba(255,255,255,0.5)", fontSize: 16, lineHeight: 1, userSelect: "none" }}
                            >
                                ×
                            </span>
                        ) : (
                            <span style={{ position: "absolute", right: 10, color: "rgba(255,255,255,0.35)", fontSize: 14, pointerEvents: "none" }}>
                                🔍
                            </span>
                        )}
                    </div>
                </div>

                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 }}>
                    {filters.map(f => (
                        <Button
                            key={f.key}
                            size="small"
                            variant={selectedFilter === f.key ? "contained" : "outlined"}
                            onClick={() => this.handleFilterChange(f.key)}
                            style={{
                                textTransform: "none",
                                minWidth: 72,
                                ...(selectedFilter === f.key
                                    ? { backgroundColor: "#ff0c9c", color: "#fff", borderColor: "#ff0c9c" }
                                    : { color: "rgba(255,255,255,0.75)", borderColor: "rgba(255,255,255,0.3)" })
                            }}
                        >
                            {f.label}
                        </Button>
                    ))}

                    {venues.length > 0 && (
                        <Select
                            multiple
                            value={selectedVenueIds}
                            onChange={this.handleVenueChange}
                            displayEmpty
                            renderValue={() => venueLabel}
                            style={{ minWidth: 160, height: 32, fontSize: 13, marginLeft: 8 }}
                        >
                            {venues.map(v => (
                                <MenuItem key={v.id} value={v.id}>
                                    <Checkbox
                                        checked={selectedVenueIds.map(String).includes(String(v.id))}
                                        color="primary"
                                    />
                                    <ListItemText primary={v.profileName} />
                                </MenuItem>
                            ))}
                        </Select>
                    )}

                    {this.isFiltering() && (
                        <Button
                            size="small"
                            onClick={() => {
                                clearTimeout(this._searchDebounceTimer);
                                this.setState({ selectedFilter: null, selectedVenueIds: [], startDate: null, endDate: null, showCustomPicker: false, currentPage: 1, searchInput: "", searchQuery: "" });
                            }}
                            style={{ textTransform: "none", color: "rgba(255,255,255,0.6)", marginLeft: "auto" }}
                        >
                            Clear filters
                        </Button>
                    )}
                </div>

                {showCustomPicker && (
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 10 }}>
                            <DatePicker
                                value={startDate}
                                onChange={val => this.setState({ startDate: val ? moment(val).startOf("day") : null, currentPage: 1 })}
                                format="DD-MM-YYYY"
                                label="From"
                                autoOk
                                clearable
                                style={{ width: 140 }}
                            />
                            <DatePicker
                                value={endDate}
                                onChange={val => this.setState({ endDate: val ? moment(val).endOf("day") : null, currentPage: 1 })}
                                format="DD-MM-YYYY"
                                label="To"
                                autoOk
                                clearable
                                minDate={startDate || undefined}
                                style={{ width: 140 }}
                            />
                        </div>
                    </MuiPickersUtilsProvider>
                )}
            </div>
        );
    };

    render() {
        const { tabValue, canCreateGigPromotion, venues, oztixSyncOpen } = this.state;
        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="Gig Promotion">
                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
                            <Button
                                variant="outlined"
                                onClick={() => this.setState({ oztixSyncOpen: true })}
                                style={{ borderColor: "#ff0c9c", color: "#ff0c9c", textTransform: "none" }}
                            >
                                Sync from Oztix
                            </Button>
                            {canCreateGigPromotion && (
                                <Button
                                    variant="contained"
                                    onClick={this.handleOpenNewGigPromotionPage}
                                    style={{ backgroundColor: "#ff0c9c", color: "#fff", textTransform: "none", boxShadow: "none" }}
                                >
                                    Add Gig Promotion
                                </Button>
                            )}
                        </div>
                    </Heading>
                    <Paper style={{ position: "relative" }}>
                        <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                            <Hidden smDown>
                                <Tabs
                                    value={tabValue}
                                    onChange={this.handleTabChange}
                                    indicatorColor="primary"
                                    textColor="secondary"
                                    scrollable
                                    scrollButtons="off"
                                    classes={{ root: "tabs-root", indicator: "tabs-indicator" }}
                                >
                                    <Tab label="Draft" classes={{ selected: "tab-selected" }} />
                                    <Tab label="Published" classes={{ selected: "tab-selected" }} />
                                    <Tab label="Past" classes={{ selected: "tab-selected" }} />
                                </Tabs>
                            </Hidden>
                            <Hidden mdUp>
                                <div style={{ padding: 8 }}>
                                    <TextField
                                        select
                                        value={tabValue}
                                        onChange={this.handleSelectChange}
                                        fullWidth
                                    >
                                        <MenuItem key={0} value={0}>Draft</MenuItem>
                                        <MenuItem key={1} value={1}>Published</MenuItem>
                                        <MenuItem key={2} value={2}>Past</MenuItem>
                                    </TextField>
                                </div>
                            </Hidden>
                        </AppBar>
                        <Paper className="org-paper-form" style={{ borderRadius: "0px 0px 10px 10px", position: "relative", backgroundColor: "#3A3B3D" }}>
                            {this.renderFilterBar()}
                            <div style={{ padding: 16, backgroundColor: "#3A3B3D" }}>
                                {this.renderCurrentTab()}
                            </div>
                        </Paper>
                    </Paper>
                </MainContainer>
                <OztixSyncModal
                    open={oztixSyncOpen}
                    onClose={() => this.setState({ oztixSyncOpen: false })}
                    onSyncComplete={this.handleSyncComplete}
                    venues={venues}
                />
            </Fragment>
        );
    }
}

export default GigPromotionList;
